import { Toaster as SonnerToaster } from 'sonner';

export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast: 'rounded-xl border border-border bg-card text-foreground shadow-lg',
          title: 'font-semibold text-sm',
          description: 'text-sm text-muted-foreground',
          error: 'border-destructive/30 bg-destructive/10 text-destructive',
          success: 'border-palm/30 bg-palm/10',
          actionButton: 'bg-primary text-primary-foreground',
          cancelButton: 'bg-muted text-muted-foreground',
        },
      }}
    />
  );
}
